export const CHECKOUT_URL = 'https://smile-en.impultienda.ar/checkout/';

export const images = {
  mockup: 'https://cdn.magicpatterns.com/uploads/oouqnZvh4TbsuPu18CDTK9/MOCKUP_SMILE-EN.png',
  author: 'https://cdn.magicpatterns.com/uploads/2GRK7pJ6sgLemWapsJfYFj/Dr._Sarah_Collins_-_DENTAL.png',
};

export const COUNTDOWN_SECONDS = 17 * 60 + 34;

export const scarcity = {
  total: 150,
  remaining: 7,
};
